import {useTrans} from '@common/i18n/use-trans';
import {Link} from 'react-router-dom';

interface LogoProps {
  color?: string;
  logoColor?: string;
  isDarkMode?: boolean;
}

export function Logo({}: LogoProps) {
  const {trans} = useTrans();

  return (
    <Link
      to="/"
      className="mr-4 block h-full max-h-26 flex-shrink-0 md:mr-24 md:max-h-36"
      aria-label={trans({message: 'Go to homepage'})}
    >
      <picture>
        <source
          srcSet="/images/iaa-logo.png"
          media="(max-width: 768px)"
        />
        <source
          srcSet="/images/iaa-logo.png"
          media="(min-width: 768px)"
        />
        <img
          src="/images/iaa-logo.png"
          className="block h-full max-h-26 w-auto md:max-h-36"
          alt={trans({message: 'Site logo'})}
        />
      </picture>
    </Link>
  );
}
